import React from "react";
import GenericErrorPage from "./GenericErrorPage";

export default () => (
  <GenericErrorPage
    src="https://http.cat/404"
    alt="Not Found"
    heading="Not Found"
    description="The page you are looking for does not exist"
  />
);
